import { useEffect, useState } from "react";

const KEY = "mew.advanced";
const EVENT = "mew.advanced.change";

export function isAdvancedMode(): boolean {
  try {
    return localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

export function setAdvancedMode(on: boolean): void {
  try {
    if (on) localStorage.setItem(KEY, "1");
    else localStorage.removeItem(KEY);
  } catch {}
  window.dispatchEvent(new CustomEvent(EVENT, { detail: !!on }));
}

export function toggleAdvancedMode(): boolean {
  const next = !isAdvancedMode();
  setAdvancedMode(next);
  return next;
}

export function useAdvancedMode(): boolean {
  const [on, setOn] = useState(isAdvancedMode);
  useEffect(() => {
    const handler = () => setOn(isAdvancedMode());
    window.addEventListener(EVENT, handler);
    window.addEventListener("storage", handler);
    return () => {
      window.removeEventListener(EVENT, handler);
      window.removeEventListener("storage", handler);
    };
  }, []);
  return on;
}
